export function orderListPath(orderType) {
  return [2, 3].includes(Number(orderType))
    ? '/ucenter/staticisp/orders'
    : '/ucenter/residential/orders'
}
